import { render, staticRenderFns } from "./detailview.vue?vue&type=template&id=c65acaa6&scoped=true&"
import script from "./detailview.vue?vue&type=script&lang=js&"
export * from "./detailview.vue?vue&type=script&lang=js&"
import style0 from "./detailview.vue?vue&type=style&index=0&id=c65acaa6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65acaa6",
  null
  
)

export default component.exports